import { NavLink } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { 
  LayoutDashboard, 
  Gamepad2, 
  Image, 
  Settings,
  LogOut
} from 'lucide-react'

const navItems = [
  { path: '/', icon: LayoutDashboard, label: '仪表盘' },
  { path: '/games', icon: Gamepad2, label: '游戏管理' },
  { path: '/images', icon: Image, label: '图片管理' },
  { path: '/settings', icon: Settings, label: '系统设置' },
]

export default function Sidebar() {
  const { user, logout } = useAuthStore()

  return (
    <aside className="fixed left-0 top-0 z-50 h-full w-64 border-r border-border bg-background">
      {/* Logo */}
      <div className="flex h-14 items-center border-b border-border px-6">
        <span className="text-lg font-bold">弗瑞云游</span>
      </div>

      {/* 导航 */}
      <nav className="flex-1 space-y-1 p-4">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2 transition-colors ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* 底部用户信息 */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-border p-4">
        <div className="flex items-center justify-between">
          <div className="text-sm">
            <p className="font-medium">{user?.username}</p>
            <p className="text-muted-foreground text-xs">{user?.role}</p>
          </div>
          <button
            onClick={logout}
            className="p-2 rounded-lg hover:bg-destructive/10 hover:text-destructive transition-colors"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </aside>
  )
}
